import { AlfredTableColumn } from 'components/organisms/AlfredTable';
import { ProjectCustomData } from 'components/pages/GatewaysListPage/resources/utils';


export const AssignGatewayToProjectModalColumns = (): AlfredTableColumn<ProjectCustomData>[] => {
  return [
    {
      title: 'Alias',
      key: 'label',
      width: '40%',
      dataIndex: 'label',
    },
    {
      title: 'Id',
      key: 'value',
      width: '60%',
      dataIndex: 'value',
    },
  ];
};
